import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TAG_LIST } from '../../constants/lists';
import { ActionButton } from '../UI';
import InfoTooltip from '../InfoTooltip/Info-tooltip';
import { FooterNavigator } from '../Footer/FooterNavigator';
import TagElement from '../UI/TagList/TagElement';
import TagInput from '../UI/TagList/TagInput';
import { useStrategiesContext } from './StrategiesContext';

export const EditTags = () => {
  const {
    loadingChangeTags,
    loadingStrategies,
    strategy,
    closeModal,
    setStrategyTags,
  } = useStrategiesContext();

  const { t } = useTranslation();

  const [tags, setTags] = useState(strategy?.tags || []);
  const [isTagInputActive, setIsTagInputActive] = useState(false);
  const [showTagTip, setShowTagTip] = useState(true);

  const deleteTag = (tagToDelete: string) => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const addTag = (value: string) => {
    // TODO informs the user if the action cannot be performed
    value.trim() &&
      !tags.includes(value.trim()) &&
      setTags([...tags, value.trim()]);
    showTagTip && setShowTagTip(false);
  };

  const saveChanges = () => {
    setStrategyTags!({ variables: { strategyId: strategy?.id, tags } }).then(
      () => closeModal()
    );
  };

  return (
    <div className="flex flex-col h-96 justify-between mt-5">
      <div className="flex flex-wrap mx-16">
        {TAG_LIST.map((tagName) => (
          <TagElement
            className="mr-3 mt-3"
            key={tagName}
            name={tagName}
            isSelected={false}
            isDisabled={tags.includes(tagName)}
            onTagClick={addTag}
          />
        ))}
        {/* List of tags */}
        {tags.map((tagName) => (
          <TagElement
            className="mr-3 mt-3"
            key={tagName}
            name={tagName}
            isSelected={true}
            onCloseClick={deleteTag}
          />
        ))}

        {/* Add new tag */}
        <div className="w-full mt-8">
          <div className="w-28">
            {!isTagInputActive ? (
              <ActionButton
                onClick={() => setIsTagInputActive(true)}
                text="Add tag"
              />
            ) : (
              <InfoTooltip
                content={t('tooltips.tagList')}
                isTooltipVisible={showTagTip}
                isTooltipIconVisible
              >
                <TagInput
                  onFinish={addTag}
                  onCancel={() => setIsTagInputActive(false)}
                />
              </InfoTooltip>
            )}
          </div>
        </div>
      </div>

      {/* footer */}
      <FooterNavigator
        saveButtonName="Save"
        className="border-t-1 border-grey-30"
        loading={loadingChangeTags || loadingStrategies}
        onCancel={closeModal}
        onSave={saveChanges}
      />
    </div>
  );
};
